//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";

export default {
  created() {
    this.chkAuthen("", "");
  },
  methods: {
    callPapge(pathName) {
      let routeUrl = this.$router.resolve({
        path: pathName,
      });
      window.open(routeUrl.href, "_blank");
    },

    onItemClick(page) {
      if (page == "NIKE") {
        this.goPage("OTPMerNIKE");
      } else if (page == "VN") {
        this.goPage("OTPMerVN");
      } else if (page == "TH-NON-NIKE") {
        this.goPage("OTPMerNONNIKE");
      } else if (page == "TRM") {
        this.goPage("OTPMerTRM");
      } else if (page == "SCM") {
        this.goPage("OTPSCM");
      } else if (page == "NIKE PURCHAE") {
        this.goPage("OTPNIKE");
      } else if (page == "Procurement") {
        this.goPage("OTPProcurement");
      } else if (page == "PUMA") {
        this.goPage("p1");
      } else if (page == "NONPUMA") {
        this.goPage("p2");
      } else if (page == "NONNIKETHAI") {
        this.goPage("p4");
      } else if (page == "NONNIKETRM") {
        this.goPage("p5");
      } else if (page == "GRW") {
        this.goPage("p9");
      } else if (page == "Procurement VN") {
        this.goPage("p3");
      } else if (page == "s1") {
        this.goPage("s1");
      } else if (page == "s2") {
        this.goPage("s2");
      }
    },
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },
    exitApp() {
      this.$q
        .dialog({
          title: "Confirm",
          message: "Do you want to Exit?",
          cancel: true,
          persistent: true,
        })
        .onOk(() => {
          // console.log('>>>> OK')
          this.$router.replace({
            name: "signin",
          });
        })
        .onOk(() => {
          // console.log('>>>> second OK catcher')
        })
        .onCancel(() => {
          // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    },
  },
};
